<template>
  <div class="container">
    <!-- 页面内容 -->
    <template>
      <!-- 新增标题 -->
      <h1 class="title">
        <i class="el-icon-s-grid"></i> 企业明细数据
        <!-- 添加返回按钮 -->
        <i class="el-icon-back back-btn" @click="goBack"></i>
      </h1>
      <!-- 月份选择器和查询按钮 -->
      <div class="filter-container">
        <div class="date-pickers-wrapper">
          时间：
          <el-date-picker
            class="date-picker"
            style="width: 35%"
            size="mini"
            v-model="month"
            type="month"
            placeholder="选择月份"
            prefix-icon="el-icon-date"
          ></el-date-picker>
          类型：
          <el-select
            size="mini"
            v-model="companyType"
            style="width: 35%;margin-right:5px"
            clearable
          >
            <el-option
              label="货主企业"
              value="货主企业"
            />
            <el-option
              label="报关企业"
              value="报关企业"
            />
          </el-select>
<!--          <el-button size="mini" type="primary" class="query-btn" @click="queryData" :loading="loading">-->
<!--            <i class="el-icon-search"></i> 查询-->
<!--          </el-button>-->
        </div>
        <div class="date-pickers-wrapper" style="margin-top: 10px">
          企业：
          <el-input
            v-model="companyName"
            size="mini"
            style="width: 55%;margin-right:5px"
            clearable
          />
          <el-button size="mini" type="primary" class="query-btn" @click="queryData" :loading="loading">
            <i class="el-icon-search"></i> 查询
          </el-button>
        </div>
      </div>

      <!-- 表格区域 -->
      <div class="table-wrapper">
<!--        <div class="table-header">-->
<!--          <i class="el-icon-office-building"></i> 企业明细数据-->
<!--        </div>-->
        <el-table
          :data="tableData"
          style="width: 100%"
          :header-cell-style="tableHeaderStyle"
          v-loading="loading"
          size="mini"
          :max-height="tableHeight"
          class="custom-table">
          <el-table-column prop="name" label="企业名称" min-width="30%" align="center" fixed>
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.companyName" placement="top">
                <div class="ellipsis-text">
                  {{ scope.row.companyName }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="value" label="票数 (票)" min-width="15%" align="center">
            <template slot-scope="scope">
              <span class="blue-text">{{ formatNumber(scope.row.localCount) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="value" label="占比 (%)" min-width="15%" align="center">
            <template slot-scope="scope">
              <span class="blue-text">{{ formatPercent(scope.row.countPercentage*100) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="value" label="金额 (万元)" min-width="25%" align="center">
            <template slot-scope="scope">
              <span class="red-text">{{ scope.row.localAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="value" label="占比 (%)" min-width="15%" align="center">
            <template slot-scope="scope">
              <span class="red-text">{{ formatPercent(scope.row.amountPercentage * 100)}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
  </div>
</template>

<script>
import { codeFlag, queryEnterpriseDetails } from '@/api/app'

export default {
  data() {
    return {
      month: null,
      companyName: null,
      companyType: null,
      loading: false,
      tableData: [],
      code: '', // 添加code到data中
      tableHeaderStyle: {
        background: '#f5f7fa',
        color: '#606266',
        fontWeight: '500',
        padding: '8px 0'
      },
      windowHeight: window.innerHeight // 添加窗口高度
    }
  },
  computed: {
    // 动态计算表格高度
    tableHeight() {
      // 根据窗口高度减去其他元素高度得到表格高度
      // 200是估算的其他元素(标题、筛选器等)的总高度，可根据实际情况调整
      return `${this.windowHeight - 135}px`
    }
  },
  methods: {
    // 添加返回上级方法
    goBack() {
      this.$router.push({
        path: 'dzka'
      })
    },
    queryData() {
      // 显示加载状态
      this.loading = true
      // 格式化日期
      const startTime = this.formatDateToString(this.month)
      const endTime = this.formatDateToString2(this.month)

      // 调用查询企业明细数据接口
      queryEnterpriseDetails({
        startTime,
        endTime,
        name: this.companyName,
        code: this.code,
        type: this.companyType
      }).then(res => {
        if (res.data && res.success) {
          // 处理返回的企业明细数据
          this.tableData = res.data || []
        }
      }).catch(err => {
        console.error('查询企业明细数据失败:', err)
        this.$message.error('查询企业明细数据失败')
      }).finally(() => {
        // 关闭加载状态
        this.loading = false
      })
    },
    // 添加日期格式化方法
    formatDateToString(date) {
      if (!date) return ''
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      return `${year}-${month}` + '-01 00:00:00'
    },
    // 添加日期格式化方法
    formatDateToString2(date) {
      if (!date) return ''
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      return `${year}-${month}` + '-28 00:00:00'
    },
    // 格式化数字，添加千位分隔符
    formatNumber(num) {
      if (num === null || num === undefined) return '0'
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    // 初始化数据
    initData() {
      // 设置默认日期为上个月
      const now = new Date();
      now.setMonth(now.getMonth() - 1);
      this.month = now;
      // 初始化查询
      this.queryData()
    },
    // 格式化百分比，保留2位小数
    formatPercent(num) {
      if (num === null || num === undefined) return '0'
      return num.toFixed(2)
    }
  },
  created() {
    // 获取授权码
    this.code = localStorage.getItem('authCode')
    // 检查是否传入了code参数
    if (!this.code) {
      this.$message.warning('缺少必要参数，即将返回上级页面')
      this.$router.push({
        path: 'dzka'
      })
      return
    }
    codeFlag(this.code).then(res => {
      if (!res.data) {
        this.$message.warning('验证码过期')
        localStorage.removeItem('authCode')
        // 延迟跳转，让用户看到提示信息
        setTimeout(() => {
          this.$router.push({
            path: 'dzka'
          })
        }, 1500)
        return
      }
    })
  },
  mounted() {
    // 只有在有code的情况下才初始化数据
    if (this.code) {
      this.initData()
    }
    // 添加窗口大小变化的监听
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 组件销毁前移除监听
    window.removeEventListener('resize', this.handleResize)
  },
  // 处理窗口大小变化
  handleResize() {
    this.windowHeight = window.innerHeight;
  },
}
</script>

<style scoped>
.table-wrapper{
  flex: 1;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  overflow-y: hidden;
  /*position: fixed;*/
  height: calc(100vh - 180px); /* 添加一个备用高度，以防计算属性失效 */
}

.custom-table {
  flex: 1; /* 让表格占满容器剩余空间 */
}

.table-header {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  padding: 10px 15px;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  align-items: center;
  background-color: #fff;
}

.table-header i {
  margin-right: 8px;
  /* color: #409EFF; */
  font-size: 18px;
}

.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #f5f7fa;
  min-height: 100vh; /* 确保容器至少占满整个视口高度 */
  height: 100vh; /* 设置为视口高度 */
  overflow: hidden;
  position: fixed; /* 添加固定定位 */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* -webkit-overflow-scrolling: touch; */ /* 注释掉这个属性，它会启用滚动回弹效果 */
}

.table-wrapper{
  flex: 1;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  overflow: hidden; /* 修改为overflow: hidden */
  /* position: fixed; */ /* 移除这个属性，避免定位冲突 */
  height: calc(100vh - 180px); /* 保留备用高度 */
  -webkit-overflow-scrolling: auto; /* 添加这个属性，禁用弹性滚动 */
}

.filter-container {
  display: flex;
  flex-direction: column; /* 改为纵向排列 */
  background: white;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}

.date-pickers-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 0; /* 移除底部间距 */
}

.date-picker {
  flex: 1; /* 让日期选择器占据剩余空间 */
  margin-right: 10px; /* 添加右侧间距 */
}

.query-btn {
  margin-left: 10px;
  width: 80px; /* 设置固定宽度 */
  padding: 7px 15px; /* 增加上下内边距使按钮更高 */
  transition: all 0.3s;
  white-space: nowrap; /* 防止按钮文字换行 */
  border-radius: 4px; /* 增加圆角 */
  font-weight: 500; /* 加粗字体 */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
}

.query-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); /* 悬停时增强阴影效果 */
}

/* 以下是重复的样式，已合并到上面 */
.date-separator {
  margin: 0 5px;
  color: #909399;
  flex-shrink: 0; /* 防止分隔符被压缩 */
}

.title {
  color: #333;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  padding: 10px 0;
  margin: 0 0 10px 0;
  border-bottom: 1px solid #dcdfe6;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  position: relative; /* 添加相对定位 */
}

/* 添加返回按钮样式 */
.back-btn {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  color: #409EFF;
  cursor: pointer;
  transition: all 0.3s;
}

.back-btn:hover {
  color: #66b1ff;
  transform: translateY(-50%) scale(1.1);
}

.title i {
  margin-right: 8px;
  color: #409EFF;
}

.data-display {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin: 0 0 10px 0;
  padding: 10px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}

.data-item {
  background: #f9f9f9;
  padding: 12px 8px;
  border-radius: 6px;
  text-align: center;
  transition: all 0.3s;
  border: 1px solid #ebeef5;
}

.data-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.label {
  color: #606266;
  font-size: 14px;
  margin-bottom: 8px;
}

.value {
  color: #409EFF;
  font-size: 18px;
  font-weight: bold;
}

/* 添加图表容器样式 */
.chart-wrapper {
  background: white;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  overflow: hidden;
}

.chart-header {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.customs-chart {
  width: 100%;
  height: 300px;
}

/* 优化移动端布局 */
@media (max-width: 768px) {
  .container {
    padding: 8px;
  }

  .title {
    font-size: 18px;
    padding: 8px 0;
  }

  .filter-container {
    padding: 10px;
  }

  .date-pickers-wrapper {
    flex-wrap: nowrap; /* 确保不换行 */
  }

  .date-picker {
    max-width: calc(50% - 10px);
  }

  .date-separator {
    width: 20px;
    text-align: center;
  }

  .data-display {
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
    padding: 6px;
  }

  .data-item {
    padding: 8px 4px;
  }

  .label {
    font-size: 12px;
    margin-bottom: 4px;
  }

  .value {
    font-size: 16px;
  }
}

/* 小屏幕手机适配 */
@media (max-width: 375px) {
  .data-item {
    padding: 6px 2px;
  }

  .label {
    font-size: 11px;
  }

  .value {
    font-size: 14px;
  }
}
</style>
